import styled from 'styled-components';

export const Card = styled.div`
  background: #f4f4f2;
  border-top: 1px solid #cccccc;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  margin-bottom: 20px;
  padding: 20px;
`;

export const CardBody = styled.div`
  padding: 10px;
  display: flex;
  width: 100%;
  margin: auto;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
`;